import Image from 'next/image';

import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const PriceWithCoe: Component = ({
  subModelData,
  coeRecentTrendList,
}) => {
  const currentDate = new Date();

  const twelveMonthsAgo = new Date();

  twelveMonthsAgo.setFullYear(currentDate.getFullYear() - 1);

  const filteredPriceHistory = subModelData?.history.filter((item) => {
    const itemDate = new Date(item.date);
    return itemDate >= twelveMonthsAgo && itemDate <= currentDate;
  });

  const categoryCoeRecentTrend = coeRecentTrendList
    ?.filter(item => item.cat === subModelData?.priceDetail.coeCategory);

  const filteredPriceHistoryWithCoePrice = filteredPriceHistory?.map((item) => {
    const dateToCheck = new Date(item.date);

    const matchingData = categoryCoeRecentTrend[0].data
      .filter(coeItem => new Date(coeItem.date) <= dateToCheck)
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    const coePrice = matchingData.length > 0 ? matchingData[0].price : null;

    return {
      ...item,
      coePrice,
    };
  });

  return (
    <div className={styles.containerPriceWithCoe}>
      <div className={styles.containerTitle}>
        <div className={styles.itemTitle}>Price</div>
        <div className={styles.itemTitle}>Data</div>
        <div className={styles.itemTitle}>COE QP($)</div>
      </div>
      {filteredPriceHistoryWithCoePrice?.map((priceHistory, index, array) => {
        let sign = '';

        if (index < array.length - 1) {
          const nextPrice = array[index + 1].price;

          if (priceHistory.price > nextPrice) {
            sign = `${joinSgcmMedia('/public/new-cars/icon/redArrow.svg')}`;
          } else if (priceHistory.price < nextPrice) {
            sign = `${joinSgcmMedia('/public/new-cars/icon/greenArrow.svg')}`;
          }
        }

        const formatDateForPriceHistory = (dateString: string): string => {
          const months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ];
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, '0');
          const month = months[date.getMonth()];
          const year = String(date.getFullYear()).slice(-2);

          return `${day}-${month}-${year}`;
        };

        return (
          <div
            key={`${priceHistory.date}-${priceHistory.price}`}
            className={styles.containerTitle}>
            <div className={styles.itemPriceContent}>
              <div className={styles.containerImage}>
                { sign
                  ? (
                    <Image
                      alt="price image"
                      className={styles.imagePrice}
                      height={18}
                      src={sign}
                      width={11} />
                  )
                  : <div className={styles.imagePrice}>-</div> }
              </div>
              $
              {(priceHistory.price).toLocaleString()}
              {' '}
              with COE
            </div>
            <div className={styles.itemContent}>
              {formatDateForPriceHistory(priceHistory.date)}
            </div>
            <div className={styles.itemContent}>
              $
              {(priceHistory.coePrice)?.toLocaleString()}
              (CAT
              {' '}
              {(subModelData?.priceDetail.coeCategory)?.toUpperCase()}
              )
            </div>
          </div>
        );
      })}

    </div>
  );
};
